import { useEffect, useState } from 'react';
import { API } from '../../api';
import { Card, Form, Input, Layout, message, Modal, Select, Space, Table } from 'antd';

const OptionList = () => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<any[]>([]);
  const [editing, setEditing] = useState<any | null>(null);
  const [saving, setSaving] = useState(false);
  const [waybillColumns, setWaybillColumns] = useState<any[]>([]);
  const [form] = Form.useForm();

  useEffect(() => {
    loadData();
    loadWaybillColumns();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await API.get({ apiVersion: 'api' })(`/options/list`);
      setOptions(response.result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const loadWaybillColumns = async () => {
    try {
      const response = await API.get({ apiVersion: 'api' })(`/waybill/columns`);
      setWaybillColumns(response.result);
    } catch (error) {
      console.log(error);
    }
  };
  const isWaybillKey = (key: string) => key?.startsWith('WAYBILL_');

  const openEdit = (record: any) => {
    setEditing(record);
    const value = isWaybillKey(record.key)
      ? (record.value
          ?.split(',')
          .map((v: string) => v.trim())
          .filter(Boolean) ?? [])
      : record.value;
    form.setFieldsValue({ key: record.key, name: record.name, value });
  };

  const closeEdit = () => {
    setEditing(null);
    form.resetFields();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      if (isWaybillKey(editing?.key) && Array.isArray(values.value)) {
        values.value = values.value.join(',');
      }
      await API.post({ apiVersion: 'api' })(`/options/update`, {
        ...editing,
        ...values,
      });
      message.success('Амжилттай хадгаллаа');
      closeEdit();
      loadData();
    } catch (error: any) {
      if (error?.errorFields) return;
      console.log(error);
      message.error('Хадгалахад алдаа гарлаа');
    } finally {
      setSaving(false);
    }
  };

  const columns = [
    {
      title: 'Код',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Нэр',
      key: 'name',
      render: (record: any) => {
        return <span>{record.name}</span>;
      },
    },
    {
      title: 'Утга',
      key: 'value',
      dataIndex: 'value',
    },
  ];

  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <Card title={`Үндсэн параметр`}>
        <Space wrap style={{ marginBottom: 15 }}></Space>
        <Table
          loading={loading}
          dataSource={options}
          columns={columns}
          rowKey="no"
          onRow={(record) => ({
            onClick: () => openEdit(record),
            style: { cursor: 'pointer' },
          })}
        />
      </Card>
      <Modal
        title="Параметр засах"
        open={!!editing}
        onCancel={closeEdit}
        onOk={handleSubmit}
        confirmLoading={saving}
        okText="Хадгалах"
        cancelText="Болих"
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item label="Код" name="key">
            <Input disabled />
          </Form.Item>
          <Form.Item label="Нэр" name="name">
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="Утга"
            name="value"
            rules={[{ required: true, message: 'Утга оруулна уу' }]}
          >
            {isWaybillKey(editing?.key) ? (
              <Select
                mode="multiple"
                options={waybillColumns.map((col) => ({ value: col.code, label: col.text }))}
              />
            ) : (
              <Input />
            )}
          </Form.Item>
        </Form>
      </Modal>
    </Layout.Content>
  );
};

export default OptionList;
